import { useTranslation } from 'react-i18next';
import type { NotificationProviderStatus } from '@/api/notificationProviders/notificationProvidersApi.types';
import { MASKED_ACCOUNT_SID_PREFIX } from '@/constants/smsProvider';

interface SmsProviderSummaryProps {
  status: NotificationProviderStatus;
}

interface SummaryRowProps {
  label: string;
  value: string | null;
}

function SummaryRow({ label, value }: SummaryRowProps) {
  if (value === null || value.length === 0) {
    return null;
  }
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:gap-3 min-w-0">
      <dt className="text-xs text-zoomuted sm:w-44 shrink-0">{label}</dt>
      <dd className="text-sm font-medium text-zooindigo break-all">{value}</dd>
    </div>
  );
}

export function SmsProviderSummary({ status }: SmsProviderSummaryProps) {
  const { t } = useTranslation('notifications');
  const maskedAccountSid =
    status.accountSidSuffix === null ? null : MASKED_ACCOUNT_SID_PREFIX + status.accountSidSuffix;
  return (
    <div className="rounded-xl border border-zoosuccessborder bg-zoosuccessbg p-3 mb-4">
      <p className="text-xs font-bold text-zoosuccesstext mb-2">
        {t('providers.sms.summaryTitle')}
      </p>
      <dl className="flex flex-col gap-1.5">
        <SummaryRow label={t('providers.sms.accountSid')} value={maskedAccountSid} />
        <SummaryRow
          label={t('providers.sms.messagingServiceSid')}
          value={status.messagingServiceSid}
        />
        <SummaryRow label={t('providers.sms.fromNumber')} value={status.senderNumber} />
      </dl>
      <p className="text-xs text-zoomuted mt-2">{t('providers.sms.replaceHint')}</p>
    </div>
  );
}
